export const SEO = {
  baseTitle: 'SVG Jar',
  description: 'Best way to use SVG in Ember',
  author: 'Ivan Volti',
};

export const NAV_LINKS = [
  { text: 'GitHub', to: 'https://github.com/voltidev/ember-svg-jar' },
  { text: 'Issues', to: 'https://github.com/voltidev/ember-svg-jar/issues' },
  { text: 'Changelog', to: 'https://github.com/voltidev/ember-svg-jar/blob/master/packages/ember-svg-jar/CHANGELOG.md' },
];

export const FOOTER_LINKS = [
  { id: 'site', text: 'Website', to: 'https://volti.dev/' },
  { id: 'github', text: 'GitHub', to: 'https://github.com/voltidev' },
  { id: 'twitter', text: 'Twitter', to: 'https://twitter.com/voltidev' },
  { id: 'dribbble', text: 'Dribbble', to: 'https://dribbble.com/voltidev' },
];

export const MEDIUM = 'medium';
export const LARGE = 'large';

export const BREAKPOINTS = {
  [MEDIUM]: '(min-width: 800px)',
  [LARGE]: '(min-width: 1000px)',
};
